/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import Documents from '../components/Documents'
import NavigationBar from '../components/NavBar'
import 'react-dropdown/style.css'
import SubComponentDocument from '../components/SubComponentDocument'
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { 
    addDrivers,
    selectDrivers
} from '../features/drivers/driversSlice'
import {
    addImages,
    selectImages
} from '../features/imagesSliceFile/imagesSlice'

const determineOffboarded = (offboradedContent, selectedFunctionDate) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true
        case null:
            return true        
        default:
            return false
    }
}

var outsideDisincludes = []

const DocumentsForVerification = (props) => {
    useEffect( () => {
        if (props.superUser) {

        } else {
            async function postData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            async function putData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            postData('https://backendpajamas.herokuapp.com/tracker/', {
                ID: props.user_id
            }).then( response => {
                let theDate = new Date()
                let theTime = `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`
                if (response.data) {
                    response.data.forEach( ele => {
                        if (ele.date === new Date().toDateString()) {
                            let localPagesList = [...ele.pages_list, `${ele.pages_list.length}+docver+${theTime}`]
                            putData(`https://backendpajamas.herokuapp.com/trackeradditions/${ele._id}/`, {
                                pages_list: localPagesList
                            })
                        }
                    })
                }
            })
        }
    }, [])
    // redux stuff
    const reduxDrivers = useSelector(selectDrivers)
    const imageData = useSelector(selectImages)
    const dispatch = useDispatch()

    const [ driverGate, setDriverGate ] = useState(false)

    // redux set state
        // view the redux state
    useEffect( () => {
        if (reduxDrivers.length > 0 && imageData.length > 0) {
            // set the drivers
            let localDrivers = [...reduxDrivers]
            let localFinalDrivers = []
            localDrivers.forEach( driver => {
                if (driver.status !== 'verified' && !outsideDisincludes.includes(driver.driver_id)) {
                    localFinalDrivers.push(driver)
                }
            })
            localFinalDrivers.sort( (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1))
            setDrivers(localFinalDrivers)

            // set the images
            setImages(imageData)
        }
    }, [reduxDrivers, imageData, driverGate])

    var CryptoJS = require("crypto-js");
    const [ selectedDriver, setSelectedDriver ] = useState(null)
    const [ dataset, setDataset ] = useState(null)
    const [ selectedCity, setSelectedCity ] = useState('DBS2')
    const [ errorMessage, setErrorMessage ] = useState(null)
    const [ reRenderVar, setReRenderVar ] = useState(0)
    const [ drivers, setDrivers ] = useState([])
    const [ images, setImages ] = useState([])
    const [ driverList, setDriverList ] = useState([])
    const [ content, setContent ] = useState(null)
    const [stationOptions, setStationOptions] = useState(null)


    useEffect( () => {
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
            });

            return response ? response.json() : console.log('no reponse')
        };

        getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
            response.results.sort( (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1))
            dispatch(addDrivers(response.results))
            getData('https://backendpajamas.herokuapp.com/images/').then( response => {
                dispatch(addImages(response.results))
            })
        })
    }, [])
    
    // make a rerender
    const makeAReRender = (aDriver) => {
        if (aDriver) {
            async function postData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                    });
    
                return response ? response.json() : console.log('no reponse')
            };
            async function putData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                    });
    
                return response ? response.json() : console.log('no reponse')
            };
            postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                "driver_id": aDriver.driver_id
            }).then( response => {
                setSelectedDriver(null)
                let localDriver = {...aDriver}
                localDriver.imgArray = response.data
                setSelectedDriver(localDriver)
                let localVar = 0
                response.data.forEach( image => {
                    console.log(image)
                    if (image.verified === "True") {
                        localVar++
                    }
                    if (image.storageBool) {
                        localVar++
                    }
                })
                if (localVar === response.data.length) {
                    outsideDisincludes.push(aDriver.driver_id)
                    putData(`https://backendpajamas.herokuapp.com/drivers/${aDriver.driver_id}/`, {
                        status: 'verified'
                    })
                }
                driverGate === false ? setDriverGate(true) : setDriverGate(false)
            })
        }
    }

    useEffect( () => {
        if (selectedDriver) {
            setContent(
                <>
                    <Documents 
                        selectedDriver={selectedDriver} 
                        loginName={props.user_name} 
                        station={props.station}
                        email={props.user_email}
                        superUser={props.superUser ? true : false}
                        reRender={makeAReRender}
                        theData={dataset}
                        userName={props.user_name}
                        renderVar={driverGate}
                    />
                </>
            )
        }
    }, [selectedDriver, driverGate])


    // get rid off error screen
    const handleDeleteError = () => {
        setErrorMessage(null)
    }

    // select driver
    const handleClick = (e, element) => {
        if (props.superUser) {
            setSelectedDriver(element)
        } else {
            if (props.station.includes(element.location) || element.location === 'DCF1') {
                setSelectedDriver(element)
            } else {
                setErrorMessage(
                    <div className='errorMessageAllPages'>
                        <h3 id='errorMessage'>Please contact supervisor if trying to alter data about driver not in your depot. </h3>
                        <button className='errorButton' onClick={handleDeleteError}>Return</button>
                    </div>
                )
            }
        }
    }

    useEffect( () => {
        let x = 0
        let localArray = []
        if (drivers.length > 0 && images.length > 0) {
            drivers.forEach( (ele, id) => {
                if (ele.location === selectedCity && determineOffboarded(ele.status)) {
                    localArray.push(
                        <SubComponentDocument 
                            ele={ele}
                            selectedCity={selectedCity}
                            images={images}
                            handleClick={handleClick}
                            id={x}
                            superUser={props.superUser}
                            email={props.user_email}
                        />
                    )
                    x++
                }
                setDriverList(localArray)
            })
        }
    }, [drivers, images, selectedCity])


    // set city
    const handleSelectCity = (e, city) => {
        setSelectedCity(city)
    }

    useEffect( () => {
        if (props.superUser === true) {
            setStationOptions(
                <ol className="sub-menu" id="makeMeWhite">
                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DBS2')}><a id="makeMeWhiteli" href="#0">DBS2</a></li>
                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DSN1')}><a id="makeMeWhiteli" href="#0">DSN1</a></li>
                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DEX2')}><a id="makeMeWhiteli" href="#0">DEX2</a></li>
                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DXP1')}><a id="makeMeWhiteli" href="#0">DXP1</a></li>
                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DCF1')}><a id="makeMeWhiteli" href="#0">DCF1</a></li>
                </ol>
            )
        } else {
            let stationList = []
            if (props.station) {
                props.station.forEach( ele => {
                    stationList.push(
                        <li className="menu-item" onClick={(e, city) => handleSelectCity(e, `${ele}`)}><a href="#0">{ele}</a></li>
                    )
                })
            }
            setStationOptions(
                <ol className="sub-menu">
                    {stationList}
                </ol>
            )
        }
    }, [props])

    var fullContent
    if (driverList) {
        fullContent = (
            <>
                {errorMessage}
                <div className='home_content'>
                    <NavigationBar title='Documents For Verification' superUser={props.superUser ? true : false} email={props.user_email}/>
                    <div className='main_content_driver_documents_two'>
                        <div className='documents_search_bar'>
                            <nav className="menu_docs_verification" id="makeMeWhite">
                                <ol id="makeMeWhite">
                                    <li className="menu-item" id="makeMeWhite"><a href="#0" id="makeMeWhite">{selectedCity}</a>
                                        {stationOptions}
                                    </li>
                                </ol>
                            </nav>
                            <div className='drivers_names_documents'>
                                {driverList}
                            </div>
                        </div>
                        {content}
                    </div>
                </div>
            </>
        )
    } else {
        fullContent = (
            <div className='home_content'>
            <NavigationBar title='Documents For Verification' superUser={props.superUser ? true : false} email={props.user_email}/>
                <div className='containerForLoader'>
                    <div class="spinner">
                        <div class="bounce1"></div>
                        <div class="bounce5"></div>
                        <div class="bounce4"></div>
                        <div class="bounce3"></div>
                        <div class="bounce2"></div>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <>
            {fullContent}
        </>
    )
}

export default DocumentsForVerification